export const TEST_EMAIL_DOMAIN = 'e2e-test.omnea.co'

export const EMAIL_SUBJECT_ONBOARD_SUPPLIER = 'Supplier assessment for testorg'
export const EMAIL_SUBJECT_LOGIN = 'Log in to Omnea'
export const EMAIL_SUBJECT_NEW_COMMENT = 'New comment on request'
export const EMAIL_SUBJECT_REQUEST_AMENDMENT = 'Amendments requested for Supplier Onboarding Form'
export const SUMMARY_APPROVAL_REQUEST_NAME_PREFIX = 'Test summary approval'
export const EMAIL_SUBJECT_SUMMARY_APPROVAL_PREFIX = `Test Action required: ${SUMMARY_APPROVAL_REQUEST_NAME_PREFIX}`
export const SUMMARY_APPROVAL_REQUEST_NAME_REJECT_PREFIX = 'Test summary approval - TO REJECT'
export const EMAIL_SUBJECT_SUMMARY_APPROVAL_REJECT_PREFIX = `Test Action required: ${SUMMARY_APPROVAL_REQUEST_NAME_REJECT_PREFIX}`
